import React, { useEffect } from "react";
import { Loader } from "components/commons";
import styles from "./dry-stock.module.scss";
import { handleRequest } from "utils";
import useProducts from "hooks/useProducts";
import DryStockMovement from "./movement/dry-stock-movement.module";
import LubricantSales from "./lubricant-sales/lubricant-sales.module";
import LpgSales from "./lpg-sales/lpg-sales.module";
import DryStockDeliveries from "./deliveries/deliveries.modules";

const DryStockTab = (props) => {
  const { inventory, setInventory, loadingShift, shift, form, pageMode } = props;
  const { fetch: fetchAllProducts, allProducts, loading } = useProducts({ withStationCode: false });

  useEffect(() => {
    handleRequest(async () => {
      if (allProducts.length <= 0) {
        await fetchAllProducts();
      }
    });
  }, [inventory, fetchAllProducts, allProducts]);

  return (
    <>
      <Loader open={loading || loadingShift} />
      {shift && allProducts.length > 0 && (
        <div className={styles.container}>
          <DryStockMovement
            shift={shift}
            form={form}
            pageMode={pageMode}
            inventory={inventory}
            setInventory={setInventory}
            allProducts={allProducts}
          />
          <DryStockDeliveries shift={shift} allProducts={allProducts} />
          <LubricantSales shift={shift} allProducts={allProducts} />
          <LpgSales shift={shift} />
        </div>
      )}
    </>
  );
};

export default DryStockTab;
